import { Navigate } from 'react-router';

const RedirectTo404 = () => {
  console.error(`User redirected from ${window.location.pathname} to /404`);

  return <Navigate to="/404" />;
};

export default RedirectTo404;
